<template>
  <div id="addBadge" class="tab-pane" role="tabpanel">
    <!-- .code -->
    <b-form-group
      id="input-group-1"
      :label="$t('countries.code')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.code"
        type="text"
        :placeholder="$t('countries.code')"
      />
    </b-form-group>
    <!-- .phone_code -->
    <b-form-group
      id="input-group-2"
      :label="$t('countries.phone_code')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.phone_code"
        type="text"
        :placeholder="$t('countries.phone_code')"
      />
    </b-form-group>
    <!-- .name -->
    <b-form-group
      id="input-group-3"
      :label="$t('countries.name')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.name"
        type="text"
        :placeholder="$t('countries.name')"
      />
    </b-form-group>

    <div class="form-group">
      <button type="button" class="btn btn-primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </button>
    </div>
  </div>
</template>

<script>
import Controller from "../../../../Controllers/CountriesController";
import config from "../../../../config/config";

const controller = new Controller();
export default {
  name: "CountriesForm",
  components: {},
  props: ["newItem"],
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, "FormData");
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
